export default {
      id: "icon-close-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-close",
      toString: function () {
        return this.url;
      }
    }